import request from '@/utils/request';

/**
 * 淘客后台的登录入口走 /admin/distribution/**：
 * 淘客账号是 type=10 + plat_type=2，按商户端(/admin/merchant/login)登会按
 * 商户管理员去查账号，根本查不到；菜单也得走淘客端才拿得到 type=10 那套。
 * 业务接口仍复用 /admin/merchant/**（LoginUserVo 把 distribution:x 镜像成 merchant:x）。
 */
export function login(data) {
  return request({
    url: '/admin/distribution/login',
    method: 'post',
    data: data
  });
}
export function getAdminInfoByTokenApi() {
  return request({
    url: '/admin/distribution/getAdminInfoByToken',
    method: 'get'
  });
}
export function logout() {
  return request({
    url: '/admin/distribution/logout',
    method: 'get'
  });
}

/**
 * 会员管理 列表
 * @param pram
 */
export function userListApi(params) {
  return request({
    url: "/admin/merchant/user/list",
    method: 'get',
    params: params
  });
}

/**
 *获取登录页图片
 */
export function getLoginPicApi() {
  return request({
    url: "/admin/distribution/getLoginPic",
    method: 'get'
  });
}

/**
 * @description 验证码
 */
export function captchaApi() {
  return request({
    url: "/publicly/validate/code/get",
    method: 'get'
  });
}

/**
 * @description 用户详情列表
 */
export function userDetailApi(id) {
  return request({
    url: "/admin/merchant/user/detail/".concat(id),
    method: 'get'
  });
}